import News from "./";

export const paths = [
  {
    path: "/news",
    component: News
  }
]
export const NewsMenu = {
    icon: "bullhorn",
    path: "/news",
    label: "Novidades",
    badge: "news",
    tree: []
};


// WEBPACK FOOTER //
// ./src/views/AppViews/News/routes.js